import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	itemArchives: {
		id: 'spa-apps-sidebar-next-gen.menu.item-archives',
		defaultMessage: 'Archived issues',
		description: '"Archived issues" menu item.',
	},
	itemBack: {
		id: 'spa-apps-sidebar-next-gen.menu.item-back',
		defaultMessage: 'Back to project',
		description: '"Back to project" menu item.',
	},
	itemBacklog: {
		id: 'spa-apps-sidebar-next-gen.menu.item-backlog',
		defaultMessage: 'Backlog',
		description: 'Navigation item which links to a backlog page in an agility project',
	},
	itemBoard: {
		id: 'spa-apps-sidebar-next-gen.menu.item-board',
		defaultMessage: 'Board',
		description: '"Board" menu item in a next-gen project.',
	},
	itemCode: {
		id: 'spa-apps-sidebar-next-gen.menu.item-code',
		defaultMessage: 'Code',
		description:
			'"Code" menu item in a next-gen project. Code page is to manage/link between Jira project and programming code repository. See how the actual code is associated with the project.',
	},
	itemForms: {
		id: 'spa-apps-sidebar-next-gen.menu.item-forms',
		defaultMessage: 'Forms',
		description:
			'The text is shown as a next-gen software project Navigation item where it triggers the Forms page. Optimal characters is 18 or less.',
	},
	itemSummary: {
		id: 'spa-apps-sidebar-next-gen.menu.item-summary',
		defaultMessage: 'Summary',
		description: '"Summary" menu item in a next-gen project.',
	},
	itemGoals: {
		id: 'spa-apps-sidebar-next-gen.menu.item-goals',
		defaultMessage: 'Goals',
		description: '"Goals" menu item in a next-gen project.',
	},
	itemGetStarted: {
		id: 'spa-apps-sidebar-next-gen.menu.item-get-started',
		defaultMessage: 'Getting started',
		description: '"Getting started" menu item.',
	},
	itemSecurity: {
		id: 'spa-apps-sidebar-next-gen.menu.item-security',
		defaultMessage: 'Security',
		description: '"Security" menu item in a next-gen project.',
	},
	itemDeployments: {
		id: 'spa-apps-sidebar-next-gen.menu.item-deployments',
		defaultMessage: 'Deployments',
		description: '"Deployments" menu item in a next-gen project',
	},
	itemOpsGenine: {
		id: 'spa-apps-sidebar-next-gen.menu.item-ops-genine',
		defaultMessage: 'On-call',
		description: 'OpsGenie\'s "On-call schedule" menu item in a next-gen project.',
	},
	itemPages: {
		id: 'spa-apps-sidebar-next-gen.menu.item-pages',
		defaultMessage: 'Pages',
		description: '"Pages" menu item in a next-gen project.',
	},
	itemPin: {
		id: 'spa-apps-sidebar-next-gen.menu.item-pin',
		defaultMessage: 'Issues and filters',
		description: '"Issues and filters" menu item in a next-gen project.',
	},
	itemReleases: {
		id: 'spa-apps-sidebar-next-gen.menu.item-releases',
		defaultMessage: 'Releases',
		description: '"Releases" menu item in a next-gen project.',
	},
	itemPeriscopeNonFinal: {
		id: 'spa-apps-sidebar-next-gen.menu.item-periscope-non-final',
		defaultMessage: 'Development',
		description: 'Navigation item which is the title of work suggestions page sidebar',
	},
	itemReports: {
		id: 'spa-apps-sidebar-next-gen.menu.item-reports',
		defaultMessage: 'Reports',
		description: '"Reports" menu item in a next-gen project.',
	},
	itemIncidents: {
		id: 'spa-apps-sidebar-next-gen.menu.item-incidents',
		defaultMessage: 'Incidents',
		description: '"Incidents" menu item in a next-gen project.',
	},
	itemRoadmap: {
		id: 'spa-apps-sidebar-next-gen.menu.item-roadmap',
		defaultMessage: 'Roadmap',
		description: '"Roadmap" menu item in a next-gen project.',
	},
	itemTimeline: {
		id: 'spa-apps-sidebar-next-gen.menu.item-timeline',
		defaultMessage: 'Timeline',
		description: '"Timeline" menu item in a next-gen project.',
	},
	itemCalendar: {
		id: 'spa-apps-sidebar-next-gen.menu.item-calendar',
		defaultMessage: 'Calendar',
		description: '"Calendar" menu item in a next-gen project.',
	},
	itemList: {
		id: 'spa-apps-sidebar-next-gen.menu.item-list',
		defaultMessage: 'List',
		description: '"List" menu item in a next-gen project.',
	},
	itemSettings: {
		id: 'spa-apps-sidebar-next-gen.menu.item-settings',
		defaultMessage: 'Project settings',
		description: '"Project settings" menu item in a next-gen project.',
	},
	itemSin: {
		id: 'spa-apps-sidebar-next-gen.menu.item-sin',
		defaultMessage: 'Issues',
		description: '"Issues" menu item in a next-gen project.',
	},
	beta: {
		id: 'spa-apps-sidebar-next-gen.menu.beta',
		defaultMessage: 'Beta',
		description: 'Label on a menu item indicating that the feature is a beta release.',
	},
	alpha: {
		id: 'spa-apps-sidebar-next-gen.menu.alpha',
		defaultMessage: 'Alpha',
		description: 'Label on a menu item indicating that the feature is an alpha release.',
	},
	// Rebranded
	headerDescriptionTeamManaged: {
		id: 'spa-apps-sidebar-next-gen.menu.header-description-team-managed',
		defaultMessage: 'Software project',
		description: 'Project type description in a next-gen project.',
	},
	planningModule: {
		id: 'spa-apps-sidebar-next-gen.menu.planning-module',
		defaultMessage: 'PLANNING',
		description: 'Planning module section title in a classic software project.',
	},
	developmentModule: {
		id: 'spa-apps-sidebar-next-gen.menu.development-module',
		defaultMessage: 'DEVELOPMENT',
		description: 'Development module section title in a classic software project.',
	},
	operationsModule: {
		id: 'spa-apps-sidebar-next-gen.menu.operations-module',
		defaultMessage: 'OPERATIONS',
		description: 'Operations module section title in a classic software project.',
	},
	sidebarLabel: {
		id: 'spa-apps-sidebar-next-gen.menu.sidebar-label',
		defaultMessage: 'Sidebar',
		description: 'Aria-label for sidebar.',
	},
	new: {
		id: 'spa-apps-sidebar-next-gen.menu.new',
		defaultMessage: 'New',
		description: 'New lozenge shows on navigation. Indicate that the feature is new.',
	},
	itemArchivesIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.item-archives-issue-term-refresh',
		defaultMessage: 'Archived work items',
		description: 'Archived work items menu item.',
	},
	itemPinIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.item-pin-issue-term-refresh',
		defaultMessage: 'Work items and filters',
		description: 'Work items and filters menu item.',
	},
	itemSinIssueTermRefresh: {
		id: 'spa-apps-sidebar-next-gen.menu.item-sin-issue-term-refresh',
		defaultMessage: 'All work',
		description: 'Work items menu item.',
	},
});
